<div class="flxClmn">
    <div class="page-title-container flxClmn-center">
		<div class="page-title-inner-container">
        	<span class="page-title">Account Management</span>
			<more-info-c></more-info-c>
		</div>
        <div class="page-subtitle-container">
            <span class="page-subtitle">
				Protect your users' accounts against takeover
				<span style="background: var(--ui-surface-2); border-radius: 999px; padding: 2px 10px; font-size: 12px; font-weight: 600; color: var(--ui-text); margin-left: 8px; white-space: nowrap;">
					{{users?.length || 0}} protected accounts
				</span>
			</span>
        </div>
    </div>

	<div class="page-inner-content-holder no-scroll flxClmn">
		<!--users table-->
		<trustifi-table-c
				class="trustifi-table" style="flex: 1 0; z-index: 5;"
				[list]="users"
				[headers]="[
                    {text:'Name', sortKey:'name'},
                    {text:'Email', sortKey:'email', width: '35%'},
                    {text:'Status', sortKey:'status'},
                ]"
				[cellsPrototype]="[
                    {textKey: 'name'},
                    {textKey: 'email'},
                    {html: 'actionCell'},
                ]"
				[bulkActions]="{
					enable: true,
					selectBulkActionCb:	selectMultipleAction.bind(this),
					initBulkActionsFunction: showUserBulkActions.bind(this)
				}"
				[cellActions]="{
					enable: true,
					selectItemActionCb:	selectAction.bind(this),
					initActionsFunction: showMailboxActions.bind(this)
				}"
				(searchFunction)="searchUsers($event)"
				[filterData]="filterData"
				[options]="{
                    exportToCsvFunction: exportToCsv.bind(this),
                    loadingTableFlag: loadAccountsInProcess,
                    refreshFunction: getAccountCompromisedUsers.bind(this),
                    itemsNameSingular: 'user',
                }"
		>
			<ng-template #customCells let-item let-cellId="cellId">
				<!--Action cells-->
				<span style="text-transform: capitalize;" *ngIf="cellId === 'actionCell'"
					  [ngStyle]="{'color': item.misc.account_compromised.enabled ? 'green' : 'red'}">
					{{item.status}}
				</span>
			</ng-template>
		</trustifi-table-c>
	</div>

	<account-user-info *ngIf="showAccountInfoPopup"
		[showAccountInfoPopup]="showAccountInfoPopup"
		[mailboxEmail]="accountInfo.email"
		(close)="showAccountInfoPopup = false">
	</account-user-info>

	<user-incidents-info-component></user-incidents-info-component>
</div>
